import React from 'react';
import PropTypes from 'prop-types';
import UserProp from '../../propTypes/userProp';
import Brand from './Brand';
import HeaderProfile from './headerProfile/HeaderProfile';
import TopMenu from './headerProfile/TopMenu';
import CountryProp from '../../forms/Address/CountryProp';
import CurrencyProp from '../../../sections/profile/propTypes/currencyProp';
import AuthOrganizationProp from '../../../sections/profile/propTypes/authOrganizationProp';
import UserPortalMenusProp from '../../propTypes/userPortalMenusProp';

/**
 * Metronic header layout
 */
export default function Header({
  theme,
  profile,
  languages,
  availableCurrencies,
  authOrganizations,
  selectedOrganizationId,
  logo,
  availableCountries,
  bravonLanguages,
  userPortalMenus,
}) {
  return (
    <header
      id="m_header"
      className="m-grid__item m-header"
      m-minimize-offset="200"
      m-minimize-mobile-offset="200"
    >
      <div className="m-container m-container--fluid m-container--full-height">
        <div className="m-stack m-stack--ver m-stack--desktop">
          <Brand theme={theme} logo={logo} />
          <div
            className="m-stack__item m-stack__item--fluid m-header-head"
            id="m_header_nav"
          >
            <button
              type="button"
              className="m-aside-header-menu-mobile-close  m-aside-header-menu-mobile-close--skin-light "
              id="m_aside_header_menu_mobile_close_btn"
            >
              <i className="la la-close" />
            </button>
            <TopMenu userPortalMenus={userPortalMenus} />
            <HeaderProfile
              profile={profile}
              languages={languages}
              availableCurrencies={availableCurrencies}
              authOrganizations={authOrganizations}
              selectedOrganizationId={selectedOrganizationId}
              theme={theme}
              availableCountries={availableCountries}
              bravonLanguages={bravonLanguages}
            />
          </div>
        </div>
      </div>
    </header>
  );
}

Header.propTypes = {
  /** metronic theme in use */
  theme: PropTypes.string.isRequired,
  /** member currently logged in */
  profile: PropTypes.shape(UserProp.propType),
  logo: PropTypes.string,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType)),
  availableCurrencies: PropTypes.arrayOf(
    PropTypes.shape(CurrencyProp.propType),
  ),
  selectedOrganizationId: PropTypes.string,
  authOrganizations: PropTypes.arrayOf(
    PropTypes.shape(AuthOrganizationProp.propType),
  ),
  availableCountries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  bravonLanguages: PropTypes.arrayOf(PropTypes.string).isRequired,
  userPortalMenus: PropTypes.arrayOf(
    PropTypes.shape(UserPortalMenusProp.propType),
  ).isRequired,
};

Header.defaultProps = {
  profile: null,
  logo: null,
  languages: [],
  currencies: [],
  selectedOrganizationId: null,
  authOrganizations: [],
};
